import { InvoicePrice } from './invoice-price.model';

export class InvoiceLine {
  lineNumber?: number;
  billingObject: string;
  itemCode: string;
  itemDescription: string;
  price: InvoicePrice;
  comment?: string;

  constructor(values= {}) {
    Object.assign(this, values);
    this.price = this.price ? new InvoicePrice(this.price) : new InvoicePrice();
  }
}
